import axios from "axios"

const api = (method) => process.env.VUE_APP_API_URL + method;

const unwrapData = (request) => request
  .then((response) => response.data.Data)
  .catch((error) => { console.log(error); });

const unwrap = (request) => request
  .then((response) => response.data)
  .catch((error) => { console.log(error); });

const post = (method, body = {}) => axios.post(api(method), body);
const get = (method, params) => axios.get(api(method), params ? { params } : undefined);

export default {
  name: "dataService",
  //================================================================================
  // OPEN GAME / Dashboard
  //================================================================================
  async Get4Info(sessionUserID, sessionHash, cookieUserID) {
    return await unwrapData(post('Get4Info', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      CookieUserID: cookieUserID,
    }));
  },
  async GetOpenGame() {
    return await unwrapData(get('GetOpenGame'));
  },
  async GetOpenGameDetail(GameID) {
    return await unwrapData(post('GetOpenGameDetail', { GameID }));
  },
  async GetRewardDetail(RewardID) {
    return await unwrapData(post('GetRewardDetail', { RewardID }));
  },
  async AddUserToGame(GameID, SessionUserID, SessionHash) {
    return await unwrap(post('AddUserToGame', {
      GameID,
      SessionUserID,
      SessionHash,
    }));
  },
  //================================================================================
  // MY INGA
  //================================================================================
  async GetMyGame(sessionUserId, sessionHash) {
    return await unwrapData(post('GetMyGame', {
      SessionUserID: sessionUserId,
      SessionHash: sessionHash,
    }));
  },
  //================================================================================
  // MY INGA - CHOOSE REWARD
  //================================================================================
  async GetChooseRewardData(sessionUserID, sessionHash, gameID) {
    return await unwrap(post('GetChooseRewardData', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      GameID: gameID,
    }));
  },
  async ChooseReward(sessionUserID, sessionHash, gameID, rewardType, rewardDesc) {
    return await unwrap(post('ChooseReward', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      GameID: gameID,
      RewardType: rewardType,
      RewardDesc: rewardDesc,
    }));
  },
  //================================================================================
  // USER DETAIL - USER GAMES
  //================================================================================
  async GetUserGame(userID) {
    return await unwrapData(post('GetUserGame', { UserID: userID }));
  },
  //================================================================================
  // USER PROFILE - secured
  //================================================================================
  async GetCreditStatement(userID, sessionHash) {
    return await unwrapData(post('GetCreditStatement', {
      SessionHash: sessionHash,
      SessionUserID: userID,
    }));
  },
  async GetUserSetting(userID, sessionHash) {
    return await unwrap(post('GetUserSetting', {
      SessionUserID: userID,
      SessionHash: sessionHash,
    }));
  },
  async GetUserAccount(userID, sessionHash) {
    return await unwrap(post('GetUserAccount', {
      SessionUserID: userID,
      SessionHash: sessionHash,
    }));
  },
  async SetUserSetting(userID, sessionHash, payload) {
    return await unwrap(post('SetUserSetting', {
      SessionUserID: userID,
      SessionHash: sessionHash,
      ...payload,
    }));
  },
  //================================================================================
  // USER PROFILE - CHARGE CREDIT, CHOOSE REWARD/CREDIT
  //================================================================================
  async GetPaymentQRCode(userID, sessionHash) {
    return await unwrap(post('GetPaymentQRCode', {
      SessionUserID: userID,
      SessionHash: sessionHash,
    }));
  },
  async GetWithDrawData(userID, sessionHash) {
    return await unwrap(post('GetWithDrawData', {
      SessionUserID: userID,
      SessionHash: sessionHash,
    }));
  },
  async WithDrawCode(userID, sessionHash, credit) {
    return await unwrap(post('WithDrawCode', {
      SessionUserID: userID,
      SessionHash: sessionHash,
      WithDrawAccount: credit.BankAccount.Account,
      WithDrawAmount: credit.Amount,
    }));
  },
  async WithDraw(userID, sessionHash, smsCode) {
    return await unwrap(post('WithDraw', {
      SessionUserID: userID,
      SessionHash: sessionHash,
      WithDrawCode: smsCode,
    }));
  },
  //================================================================================
  // RUNNING GAME
  //================================================================================
  async GetTop20() {
    return await unwrapData(get('GetTop20'));
  },
  async GetHistoryGame() {
    return await unwrapData(get('GetHistoryGame'));
  },
  async GetRunningGame() {
    return await unwrapData(post('GetRunningGame'));
  },
  async GetUserGamePosition(sessionUserID, sessionHash, gameID, userID) {
    return await unwrapData(post('GetUserGamePosition', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      GameID: gameID,
      UserID: userID,
    }));
  },
  async GetUserGameISINPosition(sessionUserID, sessionHash, gameID) {
    return await unwrapData(post('GetUserGameISINPosition', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      GameID: gameID,
    }));
  },
  async GetCapitalStatement(sessionUserID, sessionHash, gameID, userID) {
    return await unwrapData(post('GetCapitalStatement', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      GameID: gameID,
      UserID: userID,
    }));
  },
  async GetGameChart(sessionUserID, sessionHash, gameID, userID) {
    return await unwrapData(post('GetGameChart', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      GameID: gameID,
      UserID: userID,
    }));
  },
  async GetGameResult(gameID) {
    return await unwrapData(post('GetGameResult', { GameID: gameID }));
  },
  async GetRunningGameDetail(gameID) {
    return await unwrapData(post('GetRunningGameDetail', { GameID: gameID }));
  },
  async GetISINTrading(sessionUserID, sessionHash, gameID, ISINId) {
    return await unwrap(post('GetISINTrading', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      GameID: gameID,
      ISINID: ISINId,
    }));
  },
  //================================================================================
  // RUNNING GAME - INVESTMENT
  //================================================================================
  async Investment(sessionUserID, sessionHash, amount, gameID, ISINId, order) {
    return await unwrap(post('Investment', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      Amount: amount,
      GameID: gameID,
      ISINID: ISINId,
      ...(order || {}),
    }));
  },
  async SetPositionOrder(sessionUserID, sessionHash, gameID, ISINId, payload) {
    return await unwrap(post('SetPositionOrder', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      GameID: gameID,
      ISINID: ISINId,
      PositionOrderType: payload?.PositionOrderType,
      PositionOrderLimitPrice: payload?.PositionOrderLimitPrice,
      PositionOrderTrailing: payload?.PositionOrderTrailing ?? null,
      PositionOrderPercent: payload?.PositionOrderPercent ?? 0,
      CapitalID: payload?.CapitalID || 0,
    }));
  },
  async ClearPositionOrder(sessionUserID, sessionHash, gameID, ISINId, positionOrderType) {
    return await unwrap(post('ClearPositionOrder', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      GameID: gameID,
      ISINID: ISINId,
      PositionOrderType: positionOrderType || '',
    }));
  },
  //================================================================================
  // FAQ / Strategy / Glossary / How to play
  //================================================================================
  async GetFAQ() {
    return await unwrapData(post('GetFAQ'));
  },
  async GetStrategy() {
    return await unwrapData(get('GetStrategy'));
  },
  async GetGlossary() {
    return await unwrapData(get('GetGlossary'));
  },
  async GetHowToPlay() {
    return await unwrapData(get('GetHowToPlay'));
  },
  async GetAnimatorCondition() {
    return await unwrapData(get('GetAnimatorCondition'));
  },
  async GetRegistration(registrationToken) {
    return await unwrap(get('GetRegistration', {
      RegistrationToken: registrationToken,
      token: registrationToken,
    }));
  },
  //================================================================================
  // Notice - navbar dropdown notifications
  //================================================================================
  async GetNotice(sessionUserID, sessionHash) {
    return await unwrap(get('GetNotice', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
    }));
  },
  //================================================================================
  // HelpDesk
  //================================================================================
  async HelpDesk(helpdesk, sessionUserID, cookieUserID) {
    return await unwrap(post('HelpDesk', {
      HelpDeskName: helpdesk.name,
      HelpDeskPhone: helpdesk.phone,
      HelpDeskEmail: helpdesk.email,
      HelpDeskMessage: helpdesk.message,
      HelpDeskSessionUserID: sessionUserID,
      HelpDeskCookieUserID: cookieUserID,
    }));
  },
  //================================================================================
  // About
  //================================================================================
  async GetAbout() {
    return await unwrapData(post('GetAbout'));
  },
  async GetMarketing() {
    return await unwrapData(post('GetMarketing'));
  },
  //================================================================================
  // ISIN List - Shares
  //================================================================================
  async GetISINList() {
    return await unwrap(post('GetISINList'));
  },
  async GetISINDetail(ISINID) {
    return await unwrapData(post('GetISINDetail', { ISINID }));
  },
  async GetISINChart(ISINID, userID) {
    const payload = { ISINID };
    if (userID) payload.UserID = userID;
    return await unwrap(post('GetISINChart', payload));
  },
  //================================================================================
  // Forum (GetChat / SendChat / GetLastChat)
  //================================================================================
  async GetLastChat() {
    return await unwrapData(get('GetLastChat'));
  },
  async GetChat(payload) {
    return await unwrap(post('GetChat', payload));
  },
  async SendChat(payload) {
    return await unwrap(post('SendChat', payload));
  },
  //================================================================================
  // Voucher
  //================================================================================
  async addVoucher(sessionUserID, sessionHash, voucher) {
    return await unwrap(post('Voucher', {
      SessionUserID: sessionUserID,
      SessionHash: sessionHash,
      Voucher: voucher,
    }));
  },
}
